/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SetTemporaryPasswordRequestViewModel } from "../types/SetTemporaryPasswordRequestViewModel.ts";

export const setTemporaryPasswordRequestViewModelSchema = z.object({
  temporaryPassword: z
    .string()
    .describe("Senha temporária a ser definida para o usuário. Obrigatório.")
    .nullish(),
}) as unknown as ToZod<SetTemporaryPasswordRequestViewModel>;
